{
	/* Aggiungere on press condivisione e log out view in fondo */
}
import React, { useCallback } from "react";
import {
	View,
	Text,
	TouchableOpacity,
	Alert,
	Linking,
	BackHandler,
} from "react-native";
import {
	DrawerContentScrollView,
	DrawerItemList,
} from "@react-navigation/drawer";
// loghi
import { FontAwesome } from "@expo/vector-icons";
import { FontAwesome5 } from "@expo/vector-icons";
import { Entypo } from "@expo/vector-icons";
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import { getAuth, signOut } from "firebase/auth";
import { app } from "../utils/firebase";

const OpenURLButton = ({ url, children, icon }) => {
	const handlePress = useCallback(async () => {
		// Checking if the link is supported for links with custom URL scheme.
		const supported = await Linking.canOpenURL(url);

		if (supported) {
			// Opening the link with some app, if the URL scheme is "http" the web link should be opened
			// by some browser in the mobile
			await Linking.openURL(url);
		} else {
			Alert.alert(`Don't know how to open this URL: ${url}`);
		}
	}, [url]);

	return (
		<TouchableOpacity onPress={handlePress}>
			<View className="flex-row items-center space-x-5">
				{icon}
				<Text className="text-white">{children}</Text>
			</View>
		</TouchableOpacity>
	);
};

const CustomDrawer = (props) => {
	return (
		<View className="flex-1 bg-[#263238]">
			<DrawerContentScrollView {...props}>
				<View className="flex-1">
					{/* <View className="flex-column">
						<DrawerItemList {...props} />
					</View> */}
					{/* View social */}
					<View className="mx-2 px-3 py-5 bg-[#263238] space-y-6 border-white">
						<View>
							<OpenURLButton
								url={"https://www.youtube.com/@mateMATTIci"}
								icon={
									<MaterialCommunityIcons
										name="youtube"
										color="white"
										size={26}
									/>
								}
							>
								YouTube - mateMATTIci
							</OpenURLButton>
						</View>
						<View>
							<OpenURLButton
								url={
									"https://instagram.com/matemattici?igshid=YmMyMTA2M2Y="
								}
								icon={
									<MaterialCommunityIcons
										name="instagram"
										color="white"
										size={26}
									/>
								}
							>
								Instagram - @mateMATTIci
							</OpenURLButton>
						</View>
						<View>
							<OpenURLButton
								url={"http://tiktok.com/@matemattici"}
								icon={
									<FontAwesome5
										name="tiktok"
										size={26}
										color="white"
									/>
								}
							>
								TikTok - mateMATTIci
							</OpenURLButton>
						</View>
						{/* <View>
							<OpenURLButton
								url={"https://discord.gg/HDupwhZJ"}
								icon={
									<FontAwesome5
										name="discord"
										size={26}
										color="white"
									/>
								}
							>
								Server Discord
							</OpenURLButton>
						</View> */}
					</View>
					{/* Altro */}
					{/* <View className="mx-2 px-3 py-5 bg-[#263238] space-y-6 border-t border-white">
						<TouchableOpacity onPress={() => {}}>
							<View className="flex-row items-center space-x-5">
								<MaterialCommunityIcons
									name="share-variant-outline"
									color="white"
									size={26}
								/>
								<Text className="text-white">
									Condividi l'app ai tuoi amici
								</Text>
							</View>
						</TouchableOpacity>
						<TouchableOpacity>
							<View className="flex-row items-center space-x-5">
								<Entypo name="mail" size={26} color="white" />

								<Text className="text-white">Contattaci</Text>
							</View>
						</TouchableOpacity>
						<TouchableOpacity>
							<View className="flex-row items-center space-x-5">
								<FontAwesome
									name="diamond"
									size={26}
									color="white"
								/>
								<Text className="text-white">Premium</Text>
							</View>
						</TouchableOpacity>
						<TouchableOpacity>
							<View className="flex-row items-center space-x-5">
								<FontAwesome5
									name="piggy-bank"
									size={26}
									color="white"
								/>
								<Text className="text-white">Supportaci</Text>
							</View>
						</TouchableOpacity>
					</View> */}
				</View>
			</DrawerContentScrollView>
			{/* View finale */}
			<View className="px-3 mx-2 py-2 bg-[#263238] space-y-5 border-t border-white">
				<TouchableOpacity
					onPress={() => {
						const auth = getAuth(app);
						signOut(auth);
					}}
				>
					<View className="flex-row items-center space-x-5">
						<MaterialCommunityIcons
							name="logout"
							color="white"
							size={26}
						/>
						<Text className="text-white">Log out</Text>
					</View>
				</TouchableOpacity>
				{/* <TouchableOpacity
					onPress={() => {
						BackHandler.exitApp();
					}}
				>
					<View className="flex-row items-center space-x-5">
						<MaterialCommunityIcons
							name="close"
							color="white"
							size={26}
						/>
						<Text className="text-white">Exit</Text>
					</View>
				</TouchableOpacity> */}
			</View>
		</View>
	);
};

export default CustomDrawer;
